// extracted by mini-css-extract-plugin
module.exports = {"pieWrapper":"PieView_pieWrapper__1Sh2W","valueList":"PieView_valueList__1uXJv"};